import authHeader from "../../authentication/authservices/auth-header";
import apiClient from "../../http-common";

export const getUsersData = (searchString) => {
  return apiClient.get(`/employee/searchRMOs/${searchString}`, {
    headers: authHeader(),
  });
};

export const saveAlertingMatrix = (obj) => {
  return apiClient.post(``, obj, {
    headers: authHeader(),
  });
};
